export const extractShortId = (demoUrl: string | null): string | null => {
  if (!demoUrl) return null;

  try {
    const url = new URL(demoUrl);
    const pathParts = url.pathname.split('/').filter(Boolean);

    const redirectIndex = pathParts.indexOf('redirect');
    if (redirectIndex !== -1 && pathParts[redirectIndex + 1]) {
      return pathParts[redirectIndex + 1];
    }

    if (pathParts.length > 0) {
      const lastPart = pathParts[pathParts.length - 1];
      if (
        !lastPart.includes('api') &&
        !lastPart.includes('v1') &&
        !lastPart.includes('redirect')
      ) {
        return lastPart;
      }
    }

    if (!demoUrl.includes('/') && !demoUrl.includes('://')) {
      return demoUrl;
    }
  } catch {
    const pathMatch = demoUrl.match(/\/redirect\/([^\/\?]+)/);
    if (pathMatch && pathMatch[1]) {
      return pathMatch[1];
    }

    if (!demoUrl.includes('/') && !demoUrl.includes('://')) {
      return demoUrl;
    }
  }

  return null;
};
